/**
 * Kallai Shipping Rates Section JavaScript
 */

document.addEventListener('DOMContentLoaded', () => {
  initKallaiShippingRates();
});

if (window.Shopify) {
  document.addEventListener('shopify:section:load', initKallaiShippingRates);
}

function initKallaiShippingRates() {
  const sections = document.querySelectorAll('.kallai-shipping-rates');
  sections.forEach(section => {
    const pills = section.querySelectorAll('.kallai-shipping__pill');
    const jsonScript = section.querySelector('[data-shipping-rates-json]');
    if (!jsonScript || pills.length === 0) return;
    
    let ratesData = [];
    try {
      ratesData = JSON.parse(jsonScript.textContent);
    } catch (e) {
      console.error('Error parsing shipping rates JSON', e);
      return;
    }

    pills.forEach(pill => {
      pill.addEventListener('click', () => {
        const index = parseInt(pill.getAttribute('data-region-index'), 10);
        const data = ratesData[index];
        if (!data) return;

        // Update active class
        pills.forEach(p => p.classList.remove('is-active'));
        pill.classList.add('is-active');

        // Animate rates update
        const rateItems = section.querySelectorAll('.kallai-shipping__rate-item');
        rateItems.forEach(item => {
          item.style.opacity = '0';
          item.style.transform = 'translateY(4px)';
          item.style.transition = 'opacity 0.2s ease, transform 0.2s ease';
        });

        setTimeout(() => {
          // Update Sapling Tiers
          const saplingItems = section.querySelectorAll('.kallai-shipping__rate-item[data-item-type="sapling"]');
          saplingItems.forEach((item, idx) => {
            const tier = data.sapling_tiers ? data.sapling_tiers[idx] : null;
            const labelEl = item.querySelector('.kallai-shipping__rate-label');
            const valueEl = item.querySelector('.kallai-shipping__rate-value');
            
            if (tier && (tier.label || tier.rate)) {
              if (labelEl) labelEl.textContent = tier.label || '';
              if (valueEl) valueEl.textContent = tier.rate || '';
              item.style.display = 'flex';
            } else {
              item.style.display = 'none';
            }
          });

          // Update Standard Tiers
          const standardItems = section.querySelectorAll('.kallai-shipping__rate-item[data-item-type="standard"]');
          standardItems.forEach((item, idx) => {
            const tier = data.standard_tiers ? data.standard_tiers[idx] : null;
            const labelEl = item.querySelector('.kallai-shipping__rate-label');
            const valueEl = item.querySelector('.kallai-shipping__rate-value');
            
            if (tier && (tier.label || tier.rate)) {
              if (labelEl) labelEl.textContent = tier.label || '';
              if (valueEl) valueEl.textContent = tier.rate || '';
              item.style.display = 'flex';
            } else {
              item.style.display = 'none';
            }
          });

          // Fade back in for visible items
          rateItems.forEach(item => {
            if (item.style.display !== 'none') {
              item.style.opacity = '1';
              item.style.transform = 'translateY(0)';
            }
          });
        }, 200);
      });
    });
  });
}
